import React from "react";
import PageBase from "@vorne/gatsby-theme-marketing/components/layout/pagebase/pageBase";
import Header from "./header";
import Footer from "./footer";
import WhatComesNext from "@vorne/gatsby-theme-marketing/components/what-comes-next/what-comes-next";
import Section from "@vorne/gatsby-theme-marketing/components/section/section";

const Page = ({
  metaTitle,
  metaDescription,
  overrideTitle,
  children,
  excludeWhatComesNext = false,
}) => {
  return (
    <PageBase
      metaTitle={metaTitle}
      metaDescription={metaDescription}
      overrideTitle={overrideTitle}
    >
      <Header />
      {children}
      {excludeWhatComesNext ? null : (
        <Section>
          <WhatComesNext />
        </Section>
      )}
      <Footer />
    </PageBase>
  );
};

export default Page;
